import { ReactNode } from 'react';

import { Link as RouterLink, useLocation } from 'react-router-dom';

import {
  Button,
  Icons,
  HexIcon,
  Placeholder as StatusMessage,
} from '@cast/design-system';
import { Page } from '@cast/shared-layout-ui';

import { BASE_PATHS } from '@oneclick/constants/navigation';

type ErrorPage403Props = {
  body?: ReactNode;
  action?: ReactNode;
};

const ErrorPage403 = ({
  body = 'It seems you don’t have permissions to access the page.',
  action,
}: ErrorPage403Props) => {
  return (
    <StatusMessage
      stackProps={{ mt: 180 }}
      icon={
        <HexIcon variant="notification" icon={<Icons.Lock weight="fill" />} />
      }
      title="Access denied"
      titleProps={{ variant: 'h4' }}
      body={body}
      bodyProps={{ variant: 'P16R', sx: { whiteSpace: 'pre-line' } }}
      actions={
        action === undefined ? (
          <Button
            fullWidth
            variant="primary"
            component={RouterLink}
            to={BASE_PATHS.clusters}
            startIcon={<Icons.ArrowClockwise />}
          >
            Go to cluster list
          </Button>
        ) : (
          action
        )
      }
      testId="error-page"
    />
  );
};

export const ForbiddenPage = () => {
  const { state } = useLocation();

  return (
    <Page analytics="Forbidden">
      <ErrorPage403 body={state?.message} action={null} />
    </Page>
  );
};
